export default {
      id: "unlock-usage",
      viewBox: "0 0 23 21",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#unlock",
      toString: function () {
        return this.url;
      }
    }